import MetaBillingsCargoTaxiStatusCountersRequest from "../../api/raily/meta/billings/cargo-taxi/status-counters/meta-billings-cargo-taxi-status-counters.request";
import metaBillingsApiService from "../../api/raily/meta/meta-api.service";
import metaApiService from "../../api/raily/meta/meta-api.service";
import dataLoadErrorFactory from "../../utils/data-load-error/data-load-error.factory";
import handleErrorFactory from "../../utils/handle-error/handle-error.factory";
import HttpError from "../../utils/http/http.error";
import MetaAttentionCounters from "./attention-counters/meta-attention-counters";
import MetaAttentionCountersError from "./attention-counters/meta-attention-counters-error";
import metaAttentionCountersFactory from "./attention-counters/meta-attention-counters.factory";
import MetaBillingsCargoTaxiStatusCounters from "./billings/cargo-taxi/status-counters/meta-billings-cargo-taxi-status-counters";
import MetaBillingsCargoTaxiStatusCountersError from "./billings/cargo-taxi/status-counters/meta-billings-cargo-taxi-status-counters-error";
import MetaBillingsCargoTaxiStatusCountersParams from "./billings/cargo-taxi/status-counters/meta-billings-cargo-taxi-status-counters-params";
import metaBillingsCargoTaxiStatusCountersParamsFactory from "./billings/cargo-taxi/status-counters/meta-billings-cargo-taxi-status-counters-params.factory";
import metaBillingsCargoTaxiStatusCountersFactory from "./billings/cargo-taxi/status-counters/meta-billings-cargo-taxi-status-counters.factory";
import MetaBillingsTaxiTaxiStatusCounters from "./billings/taxi-taxi/status-counters/meta-billings-taxi-taxi-status-counters";
import MetaBillingsTaxiTaxiStatusCountersError from "./billings/taxi-taxi/status-counters/meta-billings-taxi-taxi-status-counters-error";
import metaBillingsTaxiTaxiStatusCountersFactory from "./billings/taxi-taxi/status-counters/meta-billings-taxi-taxi-status-counters.factory";

const getAttentionCounters = async (
  abortSignal: AbortSignal,
): Promise<MetaAttentionCounters> => {
  try {
    const response = await metaApiService().getAttentionCounters(abortSignal);

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const metaAttentionCounters = metaAttentionCountersFactory.create(response);

    return metaAttentionCounters;
  } catch (_error) {
    const error = _error as HttpError | MetaAttentionCountersError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getCargoTaxiStatusCounters = async (
  loadParams: MetaBillingsCargoTaxiStatusCountersParams,
  abortSignal: AbortSignal,
): Promise<MetaBillingsCargoTaxiStatusCounters> => {
  const request: MetaBillingsCargoTaxiStatusCountersRequest =
    metaBillingsCargoTaxiStatusCountersParamsFactory.create(loadParams);

  try {
    const response = await metaBillingsApiService().getCargoTaxiStatusCounters(
      request,
      abortSignal,
    );

    const metaBillingsCargoTaxiStatusCounters =
      metaBillingsCargoTaxiStatusCountersFactory.create(response);

    return metaBillingsCargoTaxiStatusCounters;
  } catch (_error) {
    const error = _error as
      | HttpError
      | MetaBillingsCargoTaxiStatusCountersError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getTaxiTaxiStatusCounters = async (
  abortSignal: AbortSignal,
): Promise<MetaBillingsTaxiTaxiStatusCounters> => {
  try {
    const response =
      await metaBillingsApiService().getTaxiTaxiStatusCounters(abortSignal);
    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return metaBillingsTaxiTaxiStatusCountersFactory.create(response.data);
  } catch (_error) {
    const error = _error as HttpError | MetaBillingsTaxiTaxiStatusCountersError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const metaBillingsService = {
  getAttentionCounters,
  getCargoTaxiStatusCounters,
  getTaxiTaxiStatusCounters,
};

export default metaBillingsService;
